exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".option-component[data-v-3e69636c] {\n  width: 100% !important;\n}\n.modal-body .form-row:last-of-type .form-group[data-v-3e69636c] {\n  margin-bottom: 0;\n}", ""]);

// exports
